import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import CardTitle from "@saleor/components/CardTitle";
import ConfirmButton, {
  ConfirmButtonTransitionState
} from "@saleor/components/ConfirmButton";
import Container from "@saleor/components/Container";
import Form from "@saleor/components/Form";
import FormSpacer from "@saleor/components/FormSpacer";
import Grid from "@saleor/components/Grid";
import { maybe } from "@saleor/misc";
import { PageFooter_pageFooter } from "@saleor/navigation/types/PageFooter";
import React from "react";
import { FormattedMessage } from "react-intl";
import { useIntl } from "react-intl";
// interface MediaPlatformFromData{
//     title: string ;
//     url: string ;
// }
// interface PaymentMethodFromData{
//     title: string ;
// }
export interface PageFooterFromData {
  id: string;
  customerService: string;
  wholesaleInquiries: string;
  mediaPlatform: string;
  paymentMethod: string;
}
export interface PageFooterProps {
  data: PageFooter_pageFooter;
  disabled: boolean;
  confirmButtonState: ConfirmButtonTransitionState;
  pageFooterSubmit: (data: PageFooterFromData) => void;
}

const PageFooter: React.FC<PageFooterProps> = ({
  data,
  disabled,
  confirmButtonState,
  pageFooterSubmit
}) => {
  const intl = useIntl();
  const initialForm: PageFooterFromData = {
    id: maybe(() => data.id, ""),
    customerService: maybe(() => data.customerService, ""),
    mediaPlatform: maybe(() => data.mediaPlatformText, ""),
    paymentMethod: maybe(() => data.paymentMethodText, ""),
    wholesaleInquiries: maybe(() => data.wholesaleInquiries, "")
  };
  return (
    <>
      <Form initial={initialForm} onSubmit={pageFooterSubmit}>
        {({ change, data, hasChanged, submit }) => (
          <Container>
            <Grid>
              <Card style={{ width: 400 }}>
                <CardTitle
                  title={intl.formatMessage({
                    defaultMessage: "Page Footer"
                  })}
                />
                <CardContent>
                  <TextField
                    disabled={disabled}
                    name={"customerService" as keyof PageFooterFromData}
                    fullWidth
                    label={intl.formatMessage({
                      defaultMessage: "Customer Service",
                      id: "customerService"
                    })}
                    value={data.customerService}
                    onChange={change}
                  />
                  <FormSpacer />
                  <TextField
                    disabled={disabled}
                    name={"wholesaleInquiries" as keyof PageFooterFromData}
                    fullWidth
                    label={intl.formatMessage({
                      defaultMessage: "Wholesale Inquiries",
                      id: "wholesaleInquiries"
                    })}
                    value={data.wholesaleInquiries}
                    onChange={change}
                  />
                  <FormSpacer />
                  <TextField
                    disabled={disabled}
                    name={"paymentMethod" as keyof PageFooterFromData}
                    fullWidth
                    label={intl.formatMessage({
                      defaultMessage: "Payment Method",
                      id: "paymentMethod"
                    })}
                    multiline={true}
                    value={data.paymentMethod}
                    onChange={change}
                    rowsMax={6}
                  />
                  <FormSpacer />
                  <TextField
                    disabled={disabled}
                    name={"mediaPlatform" as keyof PageFooterFromData}
                    fullWidth
                    multiline={true}
                    rowsMax={6}
                    label={intl.formatMessage({
                      defaultMessage: "Media Platform",
                      id: "mediaPlatform"
                    })}
                    value={data.mediaPlatform}
                    onChange={change}
                  />
                </CardContent>
              </Card>
              <FormSpacer />
              <ConfirmButton
                disabled={!hasChanged}
                transitionState={confirmButtonState}
                color="primary"
                onClick={submit}
                type="submit"
              >
                <FormattedMessage defaultMessage="Save" description="button" />
              </ConfirmButton>
            </Grid>
          </Container>
        )}
      </Form>
    </>
  );
};

export default PageFooter;
